import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Header from '../../components/header/Header';
import './login.css';
import { API_URL } from '../../Config';


function Login({setIsLoggedIn}) {
  const [selectedUser, setSelectedUser] = useState(null);
  const [userData, setUserData] = useState([]);
  const [wrongPassword, setWrongPassword] = useState(false);
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const usenavigate = useNavigate();

  useEffect(() => {
    async function fetchUserData() {
      const response = await fetch(`${API_URL}/usersdata`);
      const data = await response.json();
      setUserData(data);
    }
    fetchUserData();
  }, []);

  const handleUserCardClick = (user) => {
    setSelectedUser(user);
    setShowPasswordInput(true);
  }

  const handleUserLoginClose = () => {
    setSelectedUser(null);
    setShowPasswordInput(false);
    setWrongPassword(false);
  }


  const handleUserLogin = async (password) => {
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: selectedUser.email,
          password: password
        })
      });

      if (!response.ok) {
        const { message } = await response.json();
        setWrongPassword(true);
        throw new Error(message);
      }

      const data = await response.json();
      Cookies.set('token', data.token);
      Cookies.set('name', data.name);
      Cookies.set('type', data.type);
      setIsLoggedIn(true);
      usenavigate('/home');

    } catch (err) {
      console.error(err);
    }
  }
  let inactivityTimer;

  const handleUserActivity = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      Cookies.remove('token');
      Cookies.remove('name');
      Cookies.remove('type');
      setIsLoggedIn(false);
      usenavigate('/');
    }, 4 * 60 * 1000);
  };

const keysToWatch = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Control', 'Alt', 'Shift', 'Meta', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12', 'Tab', 'Enter', 'Backspace', 'Escape'];

document.addEventListener('keydown', (event) => {
  if (keysToWatch.includes(event.code)) {
    handleUserActivity();
  }
});
document.addEventListener('keyup', (event) => {
  if (keysToWatch.includes(event.code)) {
    handleUserActivity();
  }
});
  document.addEventListener('click', () => {
    handleUserActivity();
  });

  window.addEventListener('beforeunload', (event) => {
    if (window.location.pathname !== '/') {
      event.preventDefault();
      event.returnValue = 'You will be logged out.';
      window.addEventListener('unload', () => {
        Cookies.remove('token');
        Cookies.remove('name');
        Cookies.remove('type');
      });
    }
  });
          
    return (
    <div className='login'>
      <Header/>
      <div className="login-container">
      {showPasswordInput ? (
          <h2>Enter password</h2>
        ) : (
          <h2>Choose account for login</h2>
        )}
        {wrongPassword && <p>Wrong password</p>}
        <div className="users-card">
          {selectedUser ? (
            <UserLogin selectedUser={selectedUser} onLogin={handleUserLogin} onClose={handleUserLoginClose} />
          ) : (
            userData.map(user => (
              <div key={user._id} className="login-user" onClick={() => handleUserCardClick(user)}>
                <div className="user-icon">
                  <AccountCircleIcon/>
                </div>
                <p>{user.name}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}

function UserLogin({ selectedUser, onLogin, onClose }) {
  const [password, setPassword] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    onLogin(password);
  }
  return (
    <div className="user-login">
      <div className="user-login-left">
        <PersonIcon/>
      </div>
      <div className="user-login-right">
        <h3>{selectedUser.name}</h3>
        <form className="user-input" onSubmit={handleSubmit}>
          <div className="login-input">
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button type='submit' className='login-btn'>Log in</button>
          <div className='login-back-btn' onClick={onClose}>Close</div>
        </form>
      </div>
    </div>
  )
}

export default Login;
